import { useSubscription } from '@autopylot-internal/state';
import { useInstance } from '../../support/ioc/useInstance';
import { SearchDrawerWeatherState } from '../SearchDrawerWeatherState.ts';
import { PreMissionWeatherInDrawer } from './PreMissionWeatherInDrawer.tsx';
import { RevenueCatModel } from '../../paywall/revenue-cat/RevenueCatModel.ts';
import { dayjs } from '../../support/helpers/dayjs.ts';
import { useEffect } from 'react';
import { IonText } from '@ionic/react';

const WeatherHeader: React.FC<{placeName?: string}> = ({ placeName }) => {
    if (placeName) {
        return (
            <h5 style={{display: 'flex', justifyContent: 'center', margin: '0 0 30px'}}>
                <IonText>{placeName}</IonText>
            </h5>
        );
    }
};

export const SearchDrawerWeather: React.FC = () => {
    const mapLocation = useInstance(SearchDrawerWeatherState);
    useSubscription(() => mapLocation);

    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    const isUpgraded = revenueCat.hasUpgraded();

    useEffect(() => {
        mapLocation.sync();
        mapLocation.setReverseLookupEnabled(isUpgraded);
    }, [isUpgraded, mapLocation]);

    if (!mapLocation.location) {
        if (!mapLocation.isZoomedOut) {
            return null;
        }
        return (
            <div style={{padding: '0 12px', marginTop: 12}}>
                <span data-id="search-drawer-weather-heading" style={{fontSize: 16, fontWeight: 600}}>Weather</span>
                <p data-id="search-drawer-weather-zoom-prompt" style={{fontSize: 15, color: 'var(--ion-color-medium)', margin: '12px 0 25px'}}>Zoom in for weather</p>
            </div>
        );
    }

    const startTime = dayjs().startOf('hour').toISOString();
    const endTime = dayjs().startOf('hour').add(1, 'hour').toISOString();

    return (
        <div style={{padding: '0 12px', marginTop: 12}}>
            <span data-id="search-drawer-weather-heading" style={{fontSize: 16, fontWeight: 600}}>
                {mapLocation.placeName ? `Weather in ${mapLocation.placeName}` : 'Weather'}
            </span>

            <PreMissionWeatherInDrawer
                location={mapLocation.location}
                startTime={startTime}
                endTime={endTime}
                header={<WeatherHeader placeName={mapLocation.placeName}/>}
                trackingFrom="Search"
                paywallTriggerSource="search weather"
            />
        </div>
    );
};
